<div style="padding: 5%;">
    <div style="display: flex; justify-content: space-between; align-items: baseline;">
        <div style="font-size: 20px; font-family: var(--font); line-height: 1; padding: 10px 0px;">
            Are you sure You want to delete the "{{data.Businessname}}" Business?
        </div>
    </div>
    <div style="display: flex;align-items: center;">
        <div>
            <button (click)="deleteBusiness()" class="delete_button">Confirm</button>
        </div>
        <div>
            <button (click)="dialogclose()" class="delete_button">Cancel</button>
        </div>
    </div>
    
</div>
